import {
  useWisgptContextTokenLazyQuery,
  WisgptContextTokenQueryVariables,
} from "@/shared/services/api/graphql/generated";

export const useGptGateway = () => {
  const [fetchTokenQuery, { loading }] = useWisgptContextTokenLazyQuery();

  const fetchToken = async (params: WisgptContextTokenQueryVariables) => {
    const { data } = await fetchTokenQuery({
      variables: params,
      fetchPolicy: "no-cache", // Always fetch fresh, never use cache
    });
    return data?.wisgptContextToken;
  };

  return {
    fetchToken,
    loading,
  };
};
